/**
 * This file contains a simple test to verify that the domain is included in the LaunchDarkly context
 */

import { createLDUser } from './context';

/**
 * Test function to verify that the domain is included in the LaunchDarkly context
 * Run this in the browser console to verify that the domain is included
 */
export const testDomainInContext = () => {
  // Test with anonymous user
  const anonymousUser = createLDUser(null);
  console.log('Anonymous user with domain:', anonymousUser);
  
  // Test with authenticated user
  const authenticatedUser = createLDUser({
    userId: 'test-user',
    email: 'test@example.com'
  });
  console.log('Authenticated user with domain:', authenticatedUser);
  
  // Verify that the domain is included in both cases
  if (anonymousUser.custom && anonymousUser.custom.domain) {
    console.log('✅ Domain is included for anonymous users:', anonymousUser.custom.domain);
  } else {
    console.error('❌ Domain is NOT included for anonymous users');
  }
  
  if (authenticatedUser.custom && authenticatedUser.custom.domain) {
    console.log('✅ Domain is included for authenticated users:', authenticatedUser.custom.domain);
  } else {
    console.error('❌ Domain is NOT included for authenticated users');
  }
  
  return {
    anonymousUser,
    authenticatedUser
  };
};

// Export the test function to make it available in the browser console
if (typeof window !== 'undefined') {
  window.testDomainInContext = testDomainInContext;
}

export default testDomainInContext;
